/**=========================================================
 * Module: app-wizard.js
 * Handles form plugin and validation
 =========================================================*/

App.directive('appWizard', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/wizard.html',
      controller: 'FormController',
      restrict: 'E',
      replace: true,
      scope: { form: '=form' }
  };

});
